import { ComplianceAppWebComponent } from './component/ComplianceAppWebComponent';
import { WEB_COMPONENT_COMPLIANCE_APP } from '../../webcomponents.constants';

export { ComplianceAppWebComponent };

window.customElements.define(WEB_COMPONENT_COMPLIANCE_APP, ComplianceAppWebComponent);
